import API from '../../Common/API';

export async function getHomePageProducts() {
    try {
        const response = await API.get('/common/getHomePageProducts');
        return response.data;
    } catch (err) {
        console.error('Error fetching home page products:', err);
        return err;
    }
}

export async function getRegionalAds() {
    try {
        const response = await API.get('/ads/getRegionalAds');
        return response.data;
    } catch (err) {
        console.error('Error fetching regional ads:', err);
        return err;
    }
}

export async function getVehicleCards() {
    try {
        const response = await API.get('/common/getVehicleCards');
        return response.data;
    } catch (err) {
        console.error('Error fetching vehicle cards:', err);
        return err;
    }
}

export async function getHomeFreshProducts() {
    try {
        const response = await API.get('/products/getFreshProducts');
        return response.data;
    } catch (err) {
        console.error('Error fetching home fresh products:', err);
        return err;
    }
}
